import { render, staticRenderFns } from "./table.vue?vue&type=template&id=269c044a"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269c044a')) {
      api.createRecord('269c044a', component.options)
    } else {
      api.reload('269c044a', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=269c044a", function () {
      api.rerender('269c044a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/table.vue"
export default component.exports